import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/**
* THIS IS AN AUTO GENERATED FILE, CHANGES WILL NOT APPLY
*/

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 5a2 2 0 00-2 2v9h4V7a2 2 0 00-2-2m6 1v6h-2V6C10 .667 2 .667 2 6v6H0V6c0-8 12-8 12 0",
  fillRule: "evenodd"
});

var ClickTouchPress2Icon = function ClickTouchPress2Icon(_ref) {
  var className = _ref.className,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["className", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 16",
    className: className,
    style: {
      width: size * 10,
      height: size * 10
    },
    fill: "undefined",
    focusable: "false"
  }, rest), _ref2);
};

process.env.NODE_ENV !== "production" ? void 0 : void 0;
ClickTouchPress2Icon.defaultProps = {
  size: 1.5
};
export default ClickTouchPress2Icon;